import React from 'react';
import "assets/scss/themes.scss";
import './assets/scss/theme/dx.fluent.devExtremeCustom.css';
import 'font-awesome/css/font-awesome.min.css';
import Route from 'Routes/Index';
import { ToastContainer } from 'react-toastify';

const App = () => {
  return (
    <React.Fragment>
      <Route />
      <ToastContainer />
    </React.Fragment>
  );
};

export default App;
